module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-team-indicator js-team-indicator u-flex u-flex-ai--center u-flex-jc--center"
  }, [_c('div', {
    staticClass: "c-team-indicator__wrapper u-fit-w"
  }, _vm._l((_vm.teams), function(team, index) {
    return _c('div', {
      key: index,
      staticClass: "u-relative u-flex u-flex-ai--center u-flex-jc--center"
    }, [_c('div', {
      staticClass: "u-relative u-flex u-flex-ai--center u-flex-jc--end u-w1of2"
    }, [_c('div', {
      staticClass: "c-team-indicator__wrapper__item__line u-bg--white",
      class: _vm.activeIndex === index ? 'is-active u-color--white' : ''
    })]), _vm._v(" "), _c('div', {
      staticClass: "u-w1of2 u-cursor-pointer",
      on: {
        "click": function($event) {
          _vm.scrollTo(index)
        }
      }
    }, [_c('span', {
      staticClass: "c-team-indicator__wrapper__item__label t-ffamily--simplon t-fweight--bold t-fsize--xs u-uppercase",
      class: _vm.activeIndex === index || _vm.activeIndex === -1 ? 'is-active u-color--white' : ''
    }, [_vm._v(_vm._s(team.name))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73ee0320"}!./src/scripts/components/app-team-indicator/template.html
// module id = 475
// module chunks = 0